/**
 * Cookie management utility functions
 */

/**
 * Set a cookie with the specified name, value, and expiration
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Number of days until expiration (default: 30)
 */
export const setCookie = (name, value, days = 30) => {
  const date = new Date();

  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `; expires=${date.toUTCString()}`;
  const domain = window.location.hostname.includes("lunova.app")
    ? `; domain=.${window.location.hostname.split(".").slice(-2).join(".")}`
    : "";

  document.cookie = `${name}=${value}${expires}; path=/${domain}; SameSite=Lax; Secure`;
};

/**
 * Get a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();

    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length);
    }
  }

  return null;
};

/**
 * Delete a cookie by name
 * @param {string} name - Cookie name
 */
export const deleteCookie = (name) => {
  const domain = window.location.hostname.includes("lunova.app")
    ? `; domain=.${window.location.hostname.split(".").slice(-2).join(".")}`
    : "";

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domain}`;
};

/**
 * Check if a cookie exists
 * @param {string} name - Cookie name
 * @returns {boolean} True if cookie exists
 */
export const cookieExists = (name) => getCookie(name) !== null;

/**
 * Clear all cookies for the current domain
 */
export const clearAllCookies = () => {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

    if (name) {
      deleteCookie(name);
    }
  }
};
